import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ComponentBase, RentalObjectInfo, ObjectTypeInfo, DiscountModel } from 't4core';


@Component({
    selector: 'app-information-screen',
    templateUrl: './information-screen.component.html',
    styleUrls: ['./information-screen.component.css'],
    standalone: false
})
export class InformationScreenComponent extends ComponentBase implements OnInit {

  @Input() public image: string;
  @Input() public title: string;
  @Input() public primaryContent: string;
  @Input() public secondaryContent: string;
  @Input() public secondaryContentHtml: string;
  @Input() public actionContent: string;
  @Input() public showInvite: boolean = false;
  @Input() public discounts: DiscountModel;
  @Output() public viewLoaded = new EventEmitter<string>();
  @Input() public centered: boolean = false;
  @Input() public secondaryColor: boolean = false;

  @Output() public actionClick: EventEmitter<boolean> = new EventEmitter<boolean>(); 
  constructor() {
    super();
  }

  ngOnInit(): void {
  }
  public actionClickEmit() {
    this.actionClick.emit(true);
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.viewLoaded.emit('Done');
    }, 1000);

  }
}
